import {loadDocumentServicesAndThunderBolt} from './loadDocumentServicesAndTB'

export type LoadingStatus = 'started' | 'loaded' | 'error'

declare global {
    interface Window {
        waitForDocumentServices(): Promise<void>
        documentServicesLoadingState: LoadingStatus
    }
}

window.documentServicesLoadingState = 'started'

const promise = eventWrapper()
window.waitForDocumentServices = () => promise

async function eventWrapper() {
    try {
        await loadDocumentServicesAndThunderBolt()
        window.documentServicesLoadingState = 'loaded'
    } catch (e) {
        window.documentServicesLoadingState = 'error'
        throw new Error('Failed to load document services and Thunderbolt', {cause: e})
    }
}
